import { useMemo } from 'react';

const useFolderData = (categories, objects, getObjectId) => {
  const objFolderMap = useMemo(() => {
    const folderMap = {};
    categories?.forEach((folder) => {
      folder.category_items.forEach((item) => {
        folderMap[item.object_id] = folder;
      });
    });
    return folderMap;
  }, [objects, categories]);

  const objectsWithoutFolders = useMemo(() => {
    if (!objects) return [];
    return objects.filter((o) => !objFolderMap[getObjectId(o)]);
  }, [objFolderMap, objects]);

  return useMemo(() => {
    let tempArr = [];
    categories?.forEach((item) => {
      item.isFolder = true;
      item.subItems = item.category_items
        .map((i) => {
          const obj = objects?.find((g) => getObjectId(g) === i.object_id);
          if (obj) {
            return {
              ...obj,
              category_id: i.category_id,
              category_item_hash: i.hash,
            };
          }
        })
        .filter(Boolean);
      tempArr.push({ ...item, name: item.category_name, type: 'folder' });
    });
    objectsWithoutFolders.forEach((item) => {
      tempArr.push(item);
    });

    return tempArr;
  }, [categories, objects, objectsWithoutFolders]);
};

export default useFolderData;
